var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-collapse',{staticClass:"r-collapse style-collapse bordered"},_vm._l((_vm.tasks),function(task,i){return _c('tasks-modal-list-item',{key:task.task_id + i,attrs:{"task":task,"name":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }